export class SessionKeys {
    static readonly startSurveyKey = 'startSurveySession';
    static readonly logoutKey = 'isLogout';
    static readonly selectedProduct_Mod1 = 'selectedProduct';
    static readonly selectedKnowledgeId = 'selectedKnowledgeId';
    static readonly isDirectLogin = 'isDirectLogin';
    static readonly EMAnswers = 'EMAnswers';
    static readonly selectedProduct_Yongo = 'selectedProductYongo';
    static readonly ProcessCd = 'ProcessCd';
    static readonly isRetryOver = 'isRetryOver';
    static readonly isFromComeBackLater = 'isFromComeBackLater';
    static readonly firstName = 'FirstName';
    static readonly isPageReload = 'isPageReload';
}
